import { Component } from '@angular/core';

@Component({
    selector: 'app-auth-callback-page',
    templateUrl: './auth-callback-page.component.html',
    styleUrls: ['./auth-callback-page.component.scss'],
    standalone: false
})
export class AuthCallbackPageComponent { }
